// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge-gray[data-v-16412ace]{filter:grayscale(100%)}.badge-img[data-v-16412ace]{max-height:10rem}", ""]);
// Exports
module.exports = exports;
